import 'isomorphic-fetch';
import mergeWith from 'lodash-es/mergeWith';
import { isAbsoluteUrl } from 'ha/utils/isAbsoluteUrl';

export class FetchClient {
  private baseUrl: string;

  private options: RequestInit;

  private authorizationHeader?: () => string | undefined;

  constructor(
    url: string,
    options?: RequestInit,
    authorizationHeader?: () => string | undefined,
  ) {
    this.baseUrl = url;
    this.options = { credentials: 'include', ...options };
    this.authorizationHeader = authorizationHeader;
  }

  fetch(url: string, options?: RequestInit) {
    const mergedOptions = mergeWith(
      {},
      this.options,
      options || {},
      (baseOption, newOption) =>
        Array.isArray(baseOption) && Array.isArray(newOption)
          ? newOption
          : undefined,
    );

    if (this.authorizationHeader) {
      const authHeader = this.authorizationHeader();

      if (authHeader) {
        mergedOptions.headers = {
          ...mergedOptions.headers,
          Authorization: authHeader,
        };
      }
    }

    return fetch(
      isAbsoluteUrl(url) ? url : `${this.baseUrl}${url}`,
      mergedOptions,
    );
  }
}
